import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { PlanDetailsCard } from '@components/Order/Numbers/Cards';
import OrderNumbersFilter from '@components/Order/Numbers/OrderNumbersFilter';
import { PlanPrefixesCard } from '@components/Order/Numbers/PlanPrefixesCard';
import { PlanTable } from '@components/Order/Numbers/Tables';
import { checkIsReady } from '@features/queryUtils';
import { planApi } from '@reducers/plan/plan';
import { skipToken } from '@reduxjs/toolkit/query';

export const OrderNumbers = () => {
  const [searchParams] = useSearchParams();
  const [countryName, setCountryName] = useState('');
  const { planInfo } = useSelector((state) => state.plan);
  const skipQuery = !searchParams.get('country');
  const plans = planApi.useGetListQuery(
    skipQuery
      ? skipToken
      : {
          country: searchParams.get('country'),
          tos: searchParams.getAll('typeOfService'),
          type: searchParams.getAll('didType'),
        }
  );
  return (
    <Row>
      <Col md={3}>
        <OrderNumbersFilter setCountryName={setCountryName} />
      </Col>
      <Col md={9}>
        <PlanTable
          data={plans.data}
          isLoading={!checkIsReady(plans)}
          countryName={countryName}
        />
        {planInfo.showState.details ? <PlanDetailsCard /> : null}
        {planInfo.showState.prefixes ? <PlanPrefixesCard /> : null}
      </Col>
    </Row>
  );
};
